module.exports = "/static/assets/6522710dad0e4d577f33e159dc0207ef.png";